/* eslint-disable custom/no-nested-ternary -- Legacy */

import { is } from '@common/is/is'

export type TIconType = (
  'check' | 'x' | 'image' | 'cart' | 'person' | 'home' |
  'trash' | 'repeat' | 'pencil-square' | 'book' | 'clipboard' |
  'sd-card' | 'database' | 'currency-dollar' | 'clipboard-check-fill'
)

interface IProps {
  readonly type: TIconType
  readonly className?: string | readonly string[]
}

/**
 * Bootstrap ikonok támogatása.
 * @see {@link https://icons.getbootstrap.com/}
 * @param props - A lehetséges beállítások {@link IProps}.
 */
export default function Icon (props: IProps): HTMLElement {
  const additionals = is.string(props.className)
    ? [ props.className ]
    : is.array(props.className)
      ? props.className
      : []

  const cn: readonly string[] = [
    'bi',
    `bi-${ props.type }`,
    ...additionals
  ]

  return <i className={ cn } />
}
